import format from "date-fns/format";

export function getTeamMemberName(item = {}) {
  if (item.name_f || item.name_l) {
    return `${item.name_f || ""} ${item.name_l || ""}`.trim();
  }

  return item.member_name || "";
}

/** Owner account fields on teams2/member rows */
export function getAccountOwnerName(item = {}) {
  return getTeamMemberName(item);
}

export function getAccountOwnerEmail(item = {}) {
  return item.email || item.member_email || "";
}

export function getAccountOwnerInitials(item = {}) {
  return getTeamMemberInitials(item);
}

export function getTeamMemberEmail(item = {}) {
  return item.member_email || item.email || "";
}

export function getTeamMemberInitials(item = {}) {
  const name = getTeamMemberName(item);

  if (!name) {
    return "";
  }

  const parts = name
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  const first = parts[0]?.[0] || "";
  const last = parts.length > 1 ? parts[parts.length - 1]?.[0] : "";

  return `${first}${last}`.toUpperCase();
}

export function getTeamMemberAvatarUrl(item = {}) {
  return item.avatar_url || item.cover_image_url || item.member_avatar_url || null;
}

export function getTeamMemberRoleLabel(item = {}) {
  if (item.role_name) {
    return item.role_name;
  }

  const role = String(item.role);
  if (role === "1") return "View-Only";
  if (role === "2") return "Content Manager";
  if (role === "3") return "Admin";

  return null;
}

export function getMemberAccessStatusLabel(status) {
  if (String(status) === "0") return "Pending";
  if (String(status) === "1") return "Active";
  if (String(status) === "2") return "Expired";
  if (String(status) === "3") return "Declined";

  return "Unknown";
}

export function getMemberAccessGrantedDate(item = {}) {
  if (String(item.status) !== "1") {
    return null;
  }

  const dateValue = item.invite_responded || item.status_tm;

  if (!dateValue) {
    return null;
  }

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return format(date, "MM/dd/yyyy");
}

export function formatTeamMemberExpiration(item = {}) {
  if (Number(item.access_duration) !== 1 || !item.expiration_date) {
    return null;
  }

  const date = new Date(String(item.expiration_date).slice(0, 10));

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return format(date, "MM/dd/yyyy");
}

export function buildResendInvitePayload(item = {}) {
  const name = getTeamMemberName(item);
  const email = getTeamMemberEmail(item);
  let expiration;
  if (Number(item.access_duration) === 1 && item.expiration_date) {
    const raw = String(item.expiration_date);
    expiration = raw.includes(" ") ? raw : `${raw.slice(0, 10)} 00:00:00`;
  }

  return {
    email,
    name,
    role: item.role,
    access_duration: Number(item.access_duration || 0),
    expiration_date: expiration
  };
}
